import React from "react"
import { BsX } from "react-icons/bs"
import ReactDOMServer from "react-dom/server"
import { Trans, useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { PositionMetadaten } from "../../models/positionMetadaten"

interface PositionZusatzdatenViewProps {
    key: number
    index: number
    positionMetadaten: PositionMetadaten
    path: string
    onRemove: () => void
    onChange: (propertyname: string) => (value: any) => void
}

export function PositionZusatzinformationView({ onChange, index, onRemove, positionMetadaten, path }: PositionZusatzdatenViewProps) {
    const { t } = useTranslation()
    return (
        <Components.Row data-index={path}>
            <Components.Col size={5} sizeSmallDown={12}>
                <Components.FormGroup label={t("rechnung.positionen.positionMetadaten.name.label")} inline={true}>
                    <Components.TextEdit
                        placeholder={t("rechnung.positionen.positionMetadaten.name.placeholder")}
                        onChange={onChange("name")}
                        value={positionMetadaten.name}
                    />
                </Components.FormGroup>
            </Components.Col>
            <Components.Col size={5} sizeSmallDown={12}>
                <Components.FormGroup label={t("rechnung.positionen.positionMetadaten.wert.label")} inline={true}>
                    <Components.TextEdit
                        placeholder={t("rechnung.positionen.positionMetadaten.wert.placeholder")}
                        onChange={onChange("wert")}
                        value={positionMetadaten.wert}
                    />
                </Components.FormGroup>
            </Components.Col>
            <Components.Col size={2} sizeSmallDown={12} align={Components.Align.RIGHT}>
                <div style={{ marginTop: "calc(1.5em + .75rem + 2px)" }}>
                    <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={onRemove}
                        title={ReactDOMServer.renderToString(
                            <Trans t={t} i18nKey="rechnung.positionen.positionMetadaten.loescheMetadaten" values={{ index: index }} />,
                        )}
                    >
                        <BsX />
                    </button>
                </div>
            </Components.Col>
        </Components.Row>
    )
}
